// Multivariate Dependencies
import React from 'react';
import { IconNameToIconID } from '../../../common/components/Spritesheet';
export var IconStructure = function (_a) {
    var name = _a.name, className = _a.className, ariaLabel = _a.ariaLabel, pointerEvents = _a.pointerEvents;
    return (React.createElement("svg", { role: 'img', "aria-label": ariaLabel, className: className, pointerEvents: pointerEvents },
        React.createElement("use", { href: "#" + IconNameToIconID[name] })));
};
//# sourceMappingURL=IconStructure.js.map